// src/guide/forums/guide_forums.js
import {
  guide_tour_init,
  guide_tour_step_start,
  guide_tour_step,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_forums(langs) {
  let translations;
  try {
    // Charge dynamiquement le JSON correspondant (ex: guide_traduction_fr.json)
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des traductions pour la langue",
      langs,
      error
    );
    return;
  }
  const tour = guide_tour_init();

  tour.addStep({
    title: translations.forums.barreNavigation.titre,
    text: translations.forums.barreNavigation.texte,
    attachTo: {
      element: `#${(document.querySelector(
        '[id^="pv_id_"][id$="_0_header_action"]'
      ).parentElement.parentElement.id = "barre_navigation_forum")}`,
      on: "",
    },
    canClickTarget: false,
    buttons: [
      {
        action() {
          document
            .querySelector('[id^="pv_id_"][id$="_0_header_action"]')
            .click();
          setTimeout(() => {
            tour.next();
          }, 20);
        },
        text: translations.boutons.suivant,
      },
    ],
  });

  guide_tour_step(
    tour,
    translations,
    translations.forums.caracteristiques_liste_forums.titre,
    translations.forums.caracteristiques_liste_forums.texte,
    "#caracteristiques_liste_forums",
    "bottom"
  );

  guide_tour_step_complete(
    tour,
    translations,
    translations.forums.nouveau_forum.titre,
    translations.forums.nouveau_forum.texte,
    "#ajouter_nouveau_forum",
    "top"
  );

  tour.start();
}
